import { ref, reactive, computed, toRefs } from '@vue/composition-api'
import axios from "axios";
import useAlerts from '../../shared/composables/useAlerts'
import useCheckout from "../composables/useCheckout"

//make this state variable global
let isSaveModalVisible;
let cartMetaData;
let cart;

export default function useCart () {
    const { addAlert } = useAlerts();

    if (isSaveModalVisible == undefined){
        isSaveModalVisible = ref(false);
    }

    if (cartMetaData == undefined){
        cartMetaData = reactive(window.cartMetaData); //see cart.cfc getCart function for object details
    }

    if (cart == undefined){
        cart = ref(window.cart);
    }

    const showSaveModal = computed(() => isSaveModalVisible.value);

    const toggleSaveCart = () => isSaveModalVisible.value = !isSaveModalVisible.value;

    const updateCartCountBadge = (num = cart.value.itemList.length) => {
        var n = num || 0;
        if (n > 99) {
            n = num + "<sup>+</sup>";
        }
        //updates the little number badge in the header nav area
        let target = document.getElementById('c-count');
        target.innerHTML = n;
        target.classList.add("badge");
    }

    const getCart = (id = '', u = '') => {
        const params = new URLSearchParams({
            id: id,
            u: u
        });
        axios.post('/actions/cart.cfc?method=getCart', params).then(
            (resp) => {
                if (resp.status == 200) {
                    window.cartMetaData = resp.data.cartMetaData;
                    cart.value = resp.data.cart;
                    updateCartCountBadge();
                    syncCartChangestoCheckout();
                }
            }
        ).catch((error) => {
            addAlert('An error occurred loading the cart.', 'alert-danger', 7000);
            console.log(error);
        });
    }

    const loadNewCart = () => {
        const { clearTaxAndShipping } = useCheckout();
        axios.post('/actions/cart.cfc?method=newCart', {}).then(
            (response) => {
                if (response.status == 200) {
                    getCart();
                    clearTaxAndShipping();
                }
            }
        ).catch((error) => {
            addAlert('An error occurred creating new cart.', 'alert-danger', 7000);
            console.log(error);
        });
    }

    const saveCart = (cartName, cartNotes) => {
        const params = new URLSearchParams({
            cname: cartName,
            cnotes: cartNotes
        });

        return axios.post('/actions/cart.cfc?method=saveCart', params);
    }

    const getCartTotal = () => {
        return axios.get("/actions/cart.cfc?method=getPriceDisplays");
    }

    const updateItemQty = (item, newQty) => {
		if (isNaN(newQty) || newQty < 1) {
			newQty = 1;
		}
		newQty = parseInt(newQty);
        item.mainqty = newQty;

        const params = new URLSearchParams({
            item: item.name,
            qty: newQty
        });
        syncCartChangestoCheckout();
		return axios.post("/actions/cart.cfc?method=updateCartProductQuantity", params);
    }

    const getIndexFromCartItemName = (name) => cart.value.itemList.findIndex(itm => itm.name === name);

    const removeItem = (item) => {
        const { clearTaxAndShipping } = useCheckout();
        const params = new URLSearchParams({
            cartItem: item.name
        });
		axios.post("/actions/cart.cfc?method=removeCartItem", params).then(
			(resp) => {
				if (resp.status === 200) {
					updateCartCountBadge(resp.data.count);
                    getCart();
                    clearTaxAndShipping();
				}
			}
		).catch((error) => {
            addAlert('An error occurred removing cart item.', 'alert-danger', 7000);
            console.log(error);
        });
    }

    const syncWithCheckout = () => {
        return axios.get("/actions/cart.cfc?method=updateCheckout");
    }

    const syncCartChangestoCheckout = () => {
        const { itemList, pricing } = useCheckout();
        itemList.value = cart.value.itemList;
        pricing.value.formattedTotal = cart.value.pricing.formattedTotal;
        pricing.value.total = cart.value.pricing.total;
    }

    return {
        ...toRefs(cartMetaData),
        cart,
        saveCart,
        getCart,
        loadNewCart,
        removeItem,
        updateItemQty,
        toggleSaveCart,
        showSaveModal,
        updateCartCountBadge,
        getIndexFromCartItemName,
        getCartTotal,
        syncWithCheckout,
        syncCartChangestoCheckout
    }
}
